import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getAll () {
    return Api()
      .get('/v1/admin/resellers')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Reseller.Messages.LoadingResellersErrorMessage'),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
  },
  async get (uid) {
    return Api()
      .get('/v1/admin/resellers/' + uid)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Reseller.Messages.LoadingResellerErrorMessage'),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
  },

  async create (reseller) {
    return Api()
      .post('/v1/admin/resellers', {
        uid: '00000000-0000-0000-0000-000000000000',
        name: reseller.name,
        vatNumber: reseller.vatNumber,
        houseNumber: reseller.houseNumber,
        address: reseller.address,
        postalCode: reseller.postalCode,
        city: reseller.city,
        countryCode: reseller.countryCode,
        type: reseller.type,
        vendorIds: reseller.vendorIds,
        emailAddress: reseller.emailAddress,
        contactName: reseller.contactName,
        contactPhone: reseller.contactPhone,
      })
      .then(async function (response) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Reseller.Messages.CreateResellerSuccessMessage', [reseller.name]),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Reseller.Messages.CreateResellerErrorMessage', [reseller.name]),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
  },

  async update (reseller) {
    var updatedReseller = {
      uid: reseller.uid,
      name: reseller.name,
      vatNumber: reseller.vatNumber,
      houseNumber: reseller.houseNumber,
      address: reseller.address,
      postalCode: reseller.postalCode,
      city: reseller.city,
      countryCode: reseller.countryCode,
      type: reseller.type,
      vendorIds: reseller.vendorIds,
      emailAddress: reseller.emailAddress,
      contactName: reseller.contactName,
      contactPhone: reseller.contactPhone,
    }
    return Api()
      .put('/v1/admin/resellers', updatedReseller)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Reseller.Messages.UpdateResellerSuccessMessage', [updatedReseller.name]),
          color: 'success',
        })
        return { success: true, value: updatedReseller }
      })
      .catch(function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Reseller.Messages.UpdateResellerErrorMessage', [updatedReseller.name]),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
  },
}
